import React from "react";
import { Star } from "lucide-react";
import { REVIEWS } from "../lib/data";
import { useLang } from "../contexts/LanguageContext";

const Stars = ({ value, size = 18 }) => (
  <div className="flex items-center gap-1">
    {[1, 2, 3, 4, 5].map((n) => {
      const filled = n <= value;
      return (
        <Star
          key={n}
          size={size}
          className={
            filled
              ? "text-[color:var(--hd-gold)] fill-[color:var(--hd-gold)]"
              : "text-white/20"
          }
        />
      );
    })}
  </div>
);

const Testimonials = () => {
  const { t, lang } = useLang();

  return (
    <section
      id="reviews"
      className="py-24 md:py-32 relative"
      data-testid="reviews-section"
    >
      <div className="container-hd">
        <div className="max-w-3xl mb-12">
          <div className="font-serif italic text-[color:var(--hd-gold)] text-sm md:text-base mb-3">
            — {t.reviews.overline}
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-bold text-white tracking-tight">
            {t.reviews.title}
          </h2>
          <p className="text-white/60 mt-5 text-base md:text-lg">
            {t.reviews.subtitle}
          </p>
        </div>

        {REVIEWS.length === 0 ? (
          <div
            className="text-white/40 text-center py-20 border border-dashed border-white/10 rounded-2xl"
            data-testid="reviews-empty"
          >
            {t.reviews.empty}
          </div>
        ) : (
          <div
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-5"
            data-testid="reviews-grid"
          >
            {REVIEWS.map((r) => {
              const text =
                typeof r.text === "string" ? r.text : r.text[lang] || r.text.de;
              return (
                <div
                  key={r.id}
                  className="card-hover rounded-2xl p-7"
                  data-testid={`review-${r.id}`}
                >
                  <Stars value={r.rating} />
                  <p className="mt-4 text-white/80 text-[15px] leading-relaxed font-serif italic">
                    "{text}"
                  </p>
                  <div className="mt-6 flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-[color:var(--hd-gold)]/10 border border-[color:var(--hd-gold)]/30 flex items-center justify-center font-display text-[color:var(--hd-gold)]">
                      {r.name[0]?.toUpperCase()}
                    </div>
                    <div>
                      <div className="font-display text-white font-semibold text-sm">
                        {r.name}
                      </div>
                      <div className="text-white/40 text-xs">
                        {r.date
                          ? new Date(r.date).toLocaleDateString(
                              lang === "ua" ? "uk-UA" : "de-AT"
                            )
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
